
export class ControlPlaceDto {
    name;
    creationPerson;
    creationDate;
    modificationPerson;
    modificationDate;
    control;
 }